import { NgModule } from "@angular/core";

import { OverviewComponent } from "./overview.component";
import { OverviewListComponent } from "./list/overview-list.component";
import { OverviewItemComponent } from "./item/overview-item.component";
import { SharedModule } from "../../shared/shared.module";

import { MedicalIconModule } from "../shared/index";

@NgModule({
	imports: [SharedModule, MedicalIconModule],
	declarations: [OverviewComponent, OverviewListComponent, OverviewItemComponent],
	exports: [OverviewComponent],
})
export class MedDataOverviewModule {}
